import CONFIG from '@/config/config.ts';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/utils/providers/userContext/useUserContext.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import QuestionWrapper from '@/views/process/components/quizInialized/questions/QuestionWrapper.tsx';
import { useQueryClient } from '@tanstack/react-query';
import { FC, useState } from 'react';

const audioUrl = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_13.mp3';
const audio1Url = 'https://lets-orange.b-cdn.net/lektor-orange-2026/ORANGE_16.mp3';
const video2Url = `${CONFIG.CDN_VIDEO_URL}/005%20-%20Outro%20End%20-%209x16.mp4`;
const video1Url = `${CONFIG.CDN_VIDEO_URL}/004%20-%20Las%20-%20Outro%20-%209x16.mp4`;

const QuestionSegment13: FC = () => {
  const { t } = useTranslationWithPrefix('views.process.quizQuestions');
  const [nextSegmentVisible, setNextSegmentVisible] = useState(false);
  const handleNext = () => setNextSegmentVisible(true);
  const { user } = useUserContext();

  const queryClient = useQueryClient();

  const refreshProcessDetails = async () => {
    if (user?.userId) {
      await queryClient.refetchQueries({
        queryKey: [QueryKeyEnum.PROCESS, user?.userId],
      });
    }
  };
  return nextSegmentVisible ? (
    <QuestionWrapper
      audioUrl={audioUrl}
      muted={true}
      onNext={refreshProcessDetails}
      segmentContent={
        <>
          <p className="lead fw-bold">{t('questions.13.titles.2')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('questions.13.content.2')}</p>
            <p className="lead">{t('questions.13.content.3')}</p>
            <p className="lead">{t('questions.13.content.4')}</p>
            <p className="lead">{t('questions.13.content.5')}</p>
            <p className="lead">{t('questions.13.content.6')}</p>
          </div>
        </>
      }
      videoUrl={video2Url}
    />
  ) : (
    <QuestionWrapper
      audioUrl={audio1Url}
      muted={true}
      onNext={handleNext}
      segmentContent={
        <>
          <p className="lead fw-bold">{t('questions.13.titles.1')}</p>
          <div className="flex flex-column max-w-(--breakpoint-md) gap-s">
            <p className="lead">{t('questions.13.content.1')}</p>
          </div>
        </>
      }
      videoUrl={video1Url}
    />
  );
};

export default QuestionSegment13;
